import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppStorageService } from '@shared/storage/app-storage.service';

@Injectable()
export class AuthService {
    constructor(private storageService: AppStorageService) { }
    logout(reload?: boolean): void {
        this.storageService.clearToken();
       
    }
}
